import {Action} from '@ngrx/store';
import {AGeneralActionCreator} from "@ispm/core/classes/general-action-creator.abstract";
import {GeneralStoreEntity} from "@ispm/core/entities/general-store.entity";
import {ResourceDataItem} from "@ispm/core/classes/resource-data-item.class";
import {IActionToDispatch} from "@ispm/shared/interfaces/action.interface";

export enum TestBarForJobActionTypes {
  EnableConfirmButtonForJob = '[Test-bar] Enable Confirm button for job',
  PerformTasksBeforeMovingToNextJob = '[Test-bar] Perform tasks before moving to next job',
  MoveToNextJob = '[Test-bar] Move to next job',
  UpdateResources = '[Test-bar] Update resources'
}

export interface IEnableConfirmButtonForJob {
  enable: boolean;
  jobPurpose: string;
}

export class TestBarEnableConfirmButtonForJobAction implements Action {
  readonly type = TestBarForJobActionTypes.EnableConfirmButtonForJob;
  constructor(public payload: IEnableConfirmButtonForJob) { }
}

export interface IPerformTasksBeforeMovingToNextJob {
  jobPurpose: string;
  targetStepForPolling?: string;
  flowConfig?: string;
}

export class TestBarPerformTasksBeforeMovingToNextJobAction implements Action {
  readonly type = TestBarForJobActionTypes.PerformTasksBeforeMovingToNextJob;
  constructor(public payload: IPerformTasksBeforeMovingToNextJob) { }
}

export interface IMoveToNextJob {
  params: any;
  jobPurpose: string;
  targetStepForPolling?: string;
  flowConfig?: 'async' | 'sync';
  actionToDispatchOnError?: IActionToDispatch
}

export class TestBarMoveToNextJobAction implements Action {
  readonly type = TestBarForJobActionTypes.MoveToNextJob;
  constructor(public payload: IMoveToNextJob) { }
}

export class UpdateResourcesAction implements Action{
  readonly type: string = TestBarForJobActionTypes.UpdateResources;

  constructor(public payload: ResourceDataItem[]){
  }
}
